import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section aria-label="Get the toolkit" className="border-y border-grape-soft/30 bg-white/70" data-id="element-53" data-mp="3ucnd3pg51bsg">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center" data-id="element-54" data-mp="c6iu7shrtz6m">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-grape" data-id="element-55" data-mp="c83ln98sh209">
          SIGMA SMART™ — 100+ AI Prompts for Supervisors™
        </p>
        <h2 className="mt-3 font-display text-[26px] font-black uppercase leading-tight text-plum sm:text-4xl" data-id="element-56" data-mp="m46oyifdn6os">
          Organize your work. Communicate clearly. Supervise with greater consistency.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-plum/70" data-id="element-57" data-mp="vtq7fmz6gyj4">
          You do not need to rebuild every checklist, report, meeting agenda, or task plan from scratch.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-base leading-relaxed text-plum/70" data-id="element-58" data-mp="14whmdwr9icfi">
          Start with a structured prompt, provide the relevant context, review the output, and adapt it to the way your team operates.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-base font-semibold leading-relaxed text-plum" data-id="element-59" data-mp="2c6r9u52js8mj">
          Get the complete six-volume system and all five professional bonuses while the confirmed launch offer is available.
        </p>
        <div className="mt-8 flex justify-center" data-id="element-60" data-mp="2r1nrta05sact">
          <CTAButton data-id="element-61" data-mp="2r38k0sz03h7i">👉 Get 100+ AI Prompts for Supervisors™ now</CTAButton>
        </div>
      </div>
    </section>;
}